import { genieSideBySideWidth } from "@/common/genie/dock/genieDockLayout";

/**
 * The page beside a docked Genie never gets narrower than this: the panel
 * stops widening instead, and a narrower window scrolls the page sideways.
 * Admin has no rail, so this is all the page keeps (GenieHost `dock`).
 */
export const ADMIN_PAGE_MIN_WIDTH = 640;

/**
 * The room a docked Genie takes on the right, for the page beside it: the
 * shared dialog's docked width, so a resize drag moves the page as it moves
 * the panel, and a width saved on a wider window still leaves the page its
 * minimum.
 */
export const ADMIN_GENIE_DOCKED_INSET =
  genieSideBySideWidth(ADMIN_PAGE_MIN_WIDTH);
